import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Dashboard from './components/Dashboard';

type AuthScreen = 'login' | 'register' | 'forgot' | 'reset';

const AppContent = () => {
  const { user, isLoading } = useAuth();
  // Lien direct depuis le site vitrine : un visiteur qui clique sur « Essayer »
  // ne doit pas passer par l'écran de connexion, il n'a pas encore de compte.
  const [screen, setScreen] = useState<AuthScreen>(() =>
    new URLSearchParams(window.location.search).has('inscription') ? 'register' : 'login'
  );
  const [resetToken, setResetToken] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      setResetToken(token);
      setScreen('reset');
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
          <div className="text-xl text-gray-700">Chargement...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    if (screen === 'register') return <RegisterPage onNavigateToLogin={() => setScreen('login')} />;
    if (screen === 'forgot') return <ForgotPasswordPage onNavigateToLogin={() => setScreen('login')} />;
    if (screen === 'reset' && resetToken) return <ResetPasswordPage token={resetToken} onNavigateToLogin={() => setScreen('login')} />;
    return (
      <LoginPage
        onNavigateToRegister={() => setScreen('register')}
        onNavigateToForgotPassword={() => setScreen('forgot')}
      />
    );
  }

  return <Dashboard />;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;